import {motion} from 'framer-motion'
import '../CSS/DrawingModal.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { faPinterest } from '@fortawesome/free-brands-svg-icons'
import { textVariantLeft, textVariantRight, stagger, modalVariant } from '../Variants/variants'

const DrawingModal = ({image, closeModal}) =>{
    return(
        <motion.div 
        onClick={(e) => e.stopPropagation()}
        className='drawing-modal' 
        variants={modalVariant}
        initial="initial"
        animate="animate"
        layoutId={image.title}>
            <motion.button whileHover={{scale: 1.1}} className="modal-close" onClick={() => closeModal()}>
                <FontAwesomeIcon icon={faCircleXmark} />
            </motion.button>
            <motion.div className='drawing-modal-image-container'
            layoutid={image.id}>
                <motion.img 
                layoutId={image.url[0]} 
                src={image.img}
                alt="" initial={{borderRadius: "20px"}}/>
            </motion.div>
            <motion.div 
            className='drawing-text'
            variants={stagger}
            initial="initial"
            animate="animate"
            >
                <motion.h1
                variants={textVariantLeft}
                >{image.title}</motion.h1>
                <motion.p
                variants={textVariantRight}
                >{image.description}</motion.p>
        
                <motion.div className='drawing-num'>
                    {image.num}
                </motion.div>
                <motion.div className='references'
                variants={textVariantLeft}>
                    Reference(s):
                    <motion.div>
                        <a href={image.url[0]} target="_blank">
                        <FontAwesomeIcon icon={faPinterest}/></a>
                    </motion.div>
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default DrawingModal;